module.exports = __webpack_public_path__ + "img/haha.344312cf.gif";